import { Stack, styled } from '@mui/material';

export const PageTitleContainer = styled(Stack)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  marginTop: '8px',
  marginBottom: '1rem',
  position: 'sticky',
  top: '1rem',
  marginLeft: '1rem',
  marginRight: '1rem',
  zIndex: 1000,
}));

export const BackButtonContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  width: '64px',
  height: '54px',
  padding: '0 16px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  aspectRatio: '32/27',
  flexShrink: 0,
  alignSelf: 'stretch',
  cursor: 'pointer',
  backgroundColor: '#FEFEFE',
  borderRadius: '0.875rem',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
  transition: 'background-color 0.2s',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));

export const TitleContentContainer = styled(Stack)(() => ({
  display: 'flex',
  height: '54px',
  padding:
    'var(--Spacing-3, 12px) var(--Spacing-3, 12px) var(--Spacing-3, 12px) var(--Spacing-4, 16px)',
  justifyContent: 'space-between',
  alignItems: 'center',
  alignContent: 'center',
  rowGap: '10px',
  flex: '1 0 0',
  flexWrap: 'wrap',
  borderRadius: '0.875rem',
  backgroundColor: '#FEFEFE',
  boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.15)',
}));

export const HeaderContentWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  flex: '1 1 auto',
  maxWidth: '28.1875rem',
  minWidth: '12.5rem',
  height: '48px',
}));

export const TextContentWrapper = styled(Stack)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'center',
  flex: '1 1 auto',
  height: '45px',
  minWidth: 0,
  position: 'relative',
}));

export const TitleWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  minWidth: 0,
  gap: '8px',
}));

export const ButtonsContainer = styled(Stack)(() => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.5rem',
  flexShrink: 0,
}));
